import { VesselContact } from 'views/delivery-board/types/vessel-contact.type';

// These are hardcoded values received from Business / Cargill to be used for Vessel Contacts in the Delivery Board.
export const VesselContacts: VesselContact[] = [
  {
    vesselName: 'Aqua Fjell',
    mobile: '478 32 500',
    email: 'aqua.fjell@aquaship.no',
    contactPerson: 'Walter / Thomas',
  },
  {
    vesselName: 'Aqua Fjord',
    mobile: '950 38 000',
    email: 'aqua.fjord@aquaship.no',
    contactPerson: 'Sturle / Anders',
  },
  {
    vesselName: 'Aqua Junior',
    mobile: '480 06 500',
    email: 'aqua.junior@aquaship.no',
    contactPerson: 'Terje / Henry',
  },
  {
    vesselName: 'Aqua Lady',
    mobile: '480 02 600',
    email: 'aqua.lady@aquaship.no',
    contactPerson: 'John Olav / Anders',
  },
  {
    vesselName: 'Biostar',
    mobile: '906 75 195',
    email: 'ldbb@biostar.no',
    contactPerson: 'Håkon / Reinert',
  },
  {
    vesselName: 'Eidsvaag Marin',
    mobile: '974 01 981',
    email: 'marin@eidsvaag.no',
    contactPerson: 'Børge / Kurt Egil',
  },
  {
    vesselName: 'Eidsvaag Opal',
    mobile: '941 50 838',
    email: 'opal@eidsvaag.no',
    contactPerson: 'Johnny / Mats-Ove',
  },
  {
    vesselName: 'Eidsvaag Pioner',
    mobile: '948 11 019',
    email: 'pioner@eidsvaag.no',
    contactPerson: 'Vegard / Tor Arne',
  },
  {
    vesselName: 'Eidsvaag Polaris',
    mobile: '975 93 950',
    email: 'polaris@eidsvaag.no',
    contactPerson: 'Petter / Jan Peder',
  },
  {
    vesselName: 'Eidsvaag Sirius',
    mobile: '479 04 687',
    email: 'sirius@eidsvaag.no',
    contactPerson: 'Mats / Øyvind',
  },
  {
    vesselName: 'Eidsvaag Vega',
    mobile: '958 27 002',
    email: 'vega@eidsvaag.no',
    contactPerson: 'Håkon / Asbjørn',
  },
  {
    vesselName: 'Orion Olympus',
    mobile: '992 59 014',
    email: 'orion.olympus@larsengsjotransport.no',
    contactPerson: 'Kenneth / Ruben',
  },
  {
    vesselName: 'Terneskjær',
    mobile: '954 29 586',
    email: 'terneskjaer@biofeeder.no',
    contactPerson: 'Thomas / Steffen',
  },
  {
    vesselName: 'With Frohavet',
    mobile: '412 50 971',
    email: 'with.frohavet@ulvan-rederi.no',
    contactPerson: 'Oskar / Peter',
  },
  {
    vesselName: 'Vermland',
    mobile: '913 15 087',
    email: 'vermland@eidsvaag.no',
    contactPerson: 'Jonhard / Johnny',
  },
  {
    vesselName: 'Folla',
    mobile: '478 25 100',
    email: 'bro.folla@froygruppen.no',
    contactPerson: 'Marvin / Jørgen',
  },
  {
    vesselName: 'Rotsund',
    mobile: '474 84 767',
    email: 'bro.rotsund@froygruppen.no',
    contactPerson: 'Andrias / Joha',
  },
];
